export default __webpack_public_path__ + "static/media/tickets.5340e40548b5e53a2e7278a987a5f106.svg";